{
  "name": "kulaktan",
  "version": "2.3.2",
  "private": true,
  "type": "module",
  "description": "Gitar ve vokal için kulak eğitimi: duyduğunu çal, nota tanıma, vokal egzersizleri ve şarkıların akorlarını kulaktan bulma.",
  "homepage": "https://kulaktan.com",
  "packageManager": "pnpm@11.28.6",
  "engines": {
    "node": ">=22.22"
  },
  "scripts": {
    "dev": "vite",
    "build": "vite build",
    "preview": "vite preview",
    "cf:deploy": "pnpm build && wrangler deploy --tag v$npm_package_version",
    "cf:preview": "pnpm build && wrangler versions upload --tag v$npm_package_version",
    "typecheck": "tsc -p tsconfig.json && tsc -p tsconfig.node.json",
    "lint": "biome check .",
    "format": "biome check --write .",
    "test": "vitest run",
    "test:watch": "vitest",
    "test:e2e": "playwright test",
    "test:e2e:ui": "playwright test --ui",
    "test:tuner": "playwright test e2e/tuner.spec.ts --project=desktop",
    "test:audit": "playwright test -c playwright.audit.config.ts",
    "songs:check": "vitest run src/content/songs",
    "changeset": "changeset",
    "version-packages": "changeset version && node .changeset/date-release.mjs",
    "check": "pnpm typecheck && pnpm lint && pnpm test"
  },
  "dependencies": {
    "@fontsource-variable/bricolage-grotesque": "^5.3.0",
    "@fontsource-variable/caveat": "^5.3.0",
    "@fontsource-variable/figtree": "^5.3.0",
    "@fontsource-variable/jetbrains-mono": "^5.3.0",
    "react": "^19.3.1",
    "react-dom": "^19.3.1",
    "react-router": "^8.5.0"
  },
  "devDependencies": {
    "@biomejs/biome": "^2.6.2",
    "@changesets/cli": "^3.0.3",
    "@cloudflare/vite-plugin": "^1.64.0",
    "@playwright/test": "^1.64.1",
    "@types/node": "^24.19.2",
    "@types/react": "^19.3.0",
    "@types/react-dom": "^19.3.0",
    "@vitejs/plugin-react": "^6.1.2",
    "esbuild": "^0.28.2",
    "typescript": "^7.0.2",
    "vite": "^8.3.5",
    "vitest": "^5.0.5",
    "wrangler": "^4.152.0"
  }
}
